import { mapGetters } from 'vuex';
import checkPartner from './checkPartner';

export default {
  mixins: [checkPartner],
  computed: {
    ...mapGetters({
      appointments: 'profile/dashboard/appointments',
      questions: 'profile/dashboard/questions'
    }),
    links() {
      if (!this.$auth.user) {
        return [];
      }

      const links = [
        {
          title: this.$t('dashboard.menu.home'),
          location: 'dashboard',
          icon: 'home',
          mobileIcon: '$home'
        }
      ];

      if (
        this.questions.length ||
        (this.$auth.user.services && this.$auth.user.services.question === 'active')
      ) {
        links.push({
          title: this.$t('dashboard.menu.questions'),
          location: 'questions',
          icon: 'chat',
          mobileIcon: '$chat',
          data_cy: 'dashboardProfileNavigationQuestions'
        });
      }

      if (
        this.appointments.length ||
        (this.$auth.user.services && this.$auth.user.services.order === 'active')
      ) {
        links.push({
          title: this.$t('dashboard.menu.appointments'),
          location: 'appointments',
          icon: `calendar/date-${new Date().getDate()}`,
          mobileIcon: '$calendar',
          data_cy: 'dashboardProfileNavigationAppointments'
        });
      }

      if (!this.isUaRu && this.$auth.user && this.$auth.user.services.prevention === 'active') {
        links.push({
          title: this.$t('dashboard.menu.prevention'),
          location: 'prevention',
          icon: 'shield',
          mobileIcon: '$prevention',
          data_cy: 'dashboardProfileNavigationPrevention'
        });
      }

      if (!this.isUaRu && this.showArticles) {
        links.push({
          title: this.$t('dashboard.menu.explore'),
          location: 'profileExplore',
          icon:
            this.$i18n.locale === 'cs' || this.$i18n.locale === 'hu' || this.$i18n.locale === 'en'
              ? 'compass'
              : 'chat-empty',
          mobileIcon:
            this.$i18n.locale === 'cs' || this.$i18n.locale === 'hu' || this.$i18n.locale === 'en'
              ? '$compassVariableColor'
              : '$articles',
          data_cy: 'dashboardProfileNavigationArticles'
        });
      }

      return links;
    }
  }
};
